import { render, staticRenderFns } from "./fbAccount.vue?vue&type=template&id=50100d28&scoped=true"
import script from "./fbAccount.vue?vue&type=script&lang=js"
export * from "./fbAccount.vue?vue&type=script&lang=js"
import style0 from "./fbAccount.vue?vue&type=style&index=0&id=50100d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50100d28",
  null
  
)

export default component.exports